// Tab name constants
export const TAB_NAMES = {
  PRODUCT: 'Product',
  SUPPORT: 'Support',
  ARTICLES: 'Articles',
};

// Business unit constants
export const BUSINESS_UNITS = {
  PRODUCTS: 'products',
  SUPPORT: 'support',
  UNIFIED: 'unified',
  ARTICLES: 'articles',
  CONTENT: 'content',
  ALL: 'all',
};